"use client"
 
import { motion } from "framer-motion"

export function Hero() {
  return (
    <section className="relative md:h-[80vh] lg:h-[80vh]">
      {/* Mobile: Full screen container with centered logo */}
      <div className="block md:hidden relative w-full h-screen overflow-hidden mb-0">
        <motion.div 
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <div 
            className="w-full h-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-Hero-BG.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLUhlcm8tQkcuanBnIiwiaWF0IjoxNzY1MTgzNjM0LCJleHAiOjIwMjE3OTE2MzR9.F1Af9brbCpwzkOCsH72Q9or1I0pSd0U3Fzznv1xhEEg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center center'
            }}
          />
          <div className="absolute inset-0 bg-gradient-radial from-black/50 via-black/30 to-black/10" />
        </motion.div>
        
        {/* Mobile Logo Positioning - Centered vertically */}
        <motion.div
          className="absolute inset-0 flex items-center justify-center px-14 -mt-20"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <div className="w-full max-w-sm">
            <div className="relative aspect-[3/1] w-full">
              <img
                src="https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/logo/RT-LOGO-Hero-Mobile.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvbG9nby9SVC1MT0dPLUhlcm8tTW9iaWxlLnBuZyIsImlhdCI6MTc2NzY4NDM0MiwiZXhwIjoyMDgzMDQ0MzQyfQ.2w6WcCVMb6CQaxfxFyZvnr72zpp5Nj0kPFQzL7d7lgU"
                alt="Raintree Chinese Medicine and Acupuncture"
                className="w-full h-auto object-contain filter drop-shadow-lg"
                loading="eager"
                decoding="async"
              />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Desktop: Original layout */}
      <div className="hidden md:block relative h-full">
        <motion.div 
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <div 
            className="w-full h-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-Hero-BG.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLUhlcm8tQkcuanBnIiwiaWF0IjoxNzY1MTgzNjM0LCJleHAiOjIwMjE3OTE2MzR9.F1Af9brbCpwzkOCsH72Q9or1I0pSd0U3Fzznv1xhEEg')"
            }}
          />
          <div className="absolute inset-0 bg-gradient-radial from-black/50 via-black/30 to-black/10" />
        </motion.div>
        
        <motion.div
          className="absolute inset-0 flex items-center justify-center p-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <div className="w-full md:max-w-[34rem] lg:max-w-[34rem]">
            <div className="relative aspect-[3/1] w-full">
              <img
                src="https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/logo/RT-LOGO-Hero.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvbG9nby9SVC1MT0dPLUhlcm8ucG5nIiwiaWF0IjoxNzY3NjgzNjg5LCJleHAiOjIwODMwNDM2ODl9.FLjWjBgyWui6WiDJJth4faEK7RUC3X8uoZv03jPYRaU"
                alt="Raintree Chinese Medicine and Acupuncture"
                className="w-full h-auto object-contain"
                loading="eager"
                decoding="async"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}